import * as React from "react"
import { connect } from "react-redux"

import {
    Body,
    CompleteFooter,
    Table,
    RowContentCell,
    LoadingBody,
} from "@tenforce/toolbox-table-react"

import {
    getHasMoreVisibleConcepts,
    getFilteredConcepts,
    getVisibleConcepts,
    HasMoreVisibleConcepts,
    VisibleConcepts,
} from "../../selectors"
import { GlobalState } from "../../../../store"
import ConceptRow from "./ConceptRow"
import ConceptTableHeader from "./ConceptTableHeader"
import LoadMore from "./LoadMore"
import OldUIContext from "../../../../olduicontext"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../../util/Translations"
import { ConceptsInfo } from "../../index"

interface StateProps
    extends ConceptsInfo,
        VisibleConcepts,
        HasMoreVisibleConcepts {
    filteredConceptsCounter: number
}

type Props = StateProps

export class ConceptTable extends React.Component<Props> {
    static contextType = OldUIContext
    context: React.ContextType<typeof OldUIContext>

    render(): JSX.Element {
        const { isLoading, hasMore, filteredConceptsCounter, visibleConcepts } =
            this.props
        const { Concepts, NoResultsFound, _of } = Labels

        return (
            <Table data-ft-concepts-table>
                <ConceptTableHeader />
                {isLoading ? (
                    <LoadingBody id="conceptsLoading" />
                ) : (
                    <Body>
                        {filteredConceptsCounter === 0 && (
                            <RowContentCell id="conceptsNothingFound">
                                <span className="is-dimmed tw-pl-6">
                                    {NoResultsFound}
                                </span>
                            </RowContentCell>
                        )}
                        {visibleConcepts.map((concept) => (
                            <ConceptRow
                                key={concept.conceptId}
                                concept={concept}
                            />
                        ))}
                        {hasMore && <LoadMore />}
                    </Body>
                )}
                <CompleteFooter>
                    <div
                        className={`label is-dimmed tw-pl-2 ${
                            isLoading ? "is-loading is-placeholder" : ""
                        }`}
                    >
                        {isLoading ? (
                            <>
                                {Symbols.PlaceholderSmall}&nbsp;
                                {Symbols.PlaceholderTiny}&nbsp;
                                {Symbols.PlaceholderSmall}&nbsp;
                                {Symbols.PlaceholderMedium}
                            </>
                        ) : (
                            <>
                                {visibleConcepts.length <
                                    filteredConceptsCounter && (
                                    <>
                                        <span
                                            data-ft-component="numberOfVisibleConcepts"
                                            data-ft-count={
                                                visibleConcepts.length
                                            }
                                        >
                                            {visibleConcepts.length}
                                        </span>
                                        &nbsp;{_of}&nbsp;
                                    </>
                                )}
                                <span
                                    data-ft-component="numberOfConcepts"
                                    data-ft-count={filteredConceptsCounter}
                                >
                                    {filteredConceptsCounter}
                                </span>
                                &nbsp;{Concepts}
                            </>
                        )}
                    </div>
                </CompleteFooter>
            </Table>
        )
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage.conceptsInfo,
    visibleConcepts: getVisibleConcepts(state.conceptsPage.conceptsInfo),
    hasMore: getHasMoreVisibleConcepts(state.conceptsPage.conceptsInfo),
    filteredConceptsCounter: getFilteredConcepts(
        state.conceptsPage.conceptsInfo,
    ).length,
})

export default connect(mapStateToProps, {})(ConceptTable)
